module.exports = __webpack_public_path__ + "assets/svg/vr_ico_white.svg";